import { render, staticRenderFns } from "./TaksitTaahutList.vue?vue&type=template&id=6f6c248d"
import script from "./TaksitTaahutList.vue?vue&type=script&lang=ts"
export * from "./TaksitTaahutList.vue?vue&type=script&lang=ts"
import style0 from "./TaksitTaahutList.vue?vue&type=style&index=0&id=6f6c248d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports